import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import API from "utils/API";
import moment from "moment";
import ReactStrapTable from "components/reactStrapTable";

let isHaveColFilter = false;

const Encounters = ({ onDataLoading }) => {
  let initialFilters = {
    currentPage: 1,
    pageSize: 10,
    orderBy: "",
    order: "",
    filters: [],
  };

  const { patientId, tenantID } = useParams();
  const [data, setData] = useState([]);
  const [totalSize, setTotalSize] = useState(0);
  const [initFilter, setInitFilter] = useState(initialFilters);

  const fetchEncounters = async (filters = {}, hasFilter) => {
    onDataLoading(true);
    try {
      const { data } = await API.post(
        `/${tenantID}/Encounter/Patient/${parseInt(patientId)}`,
        filters
      );
      if (data) {
        setData(data.items);
        setTotalSize(data.totalRecords);
      }
      onDataLoading(false);
    } catch (error) {
      onDataLoading(false);
    }
  };

  useEffect(() => {
    fetchEncounters(initialFilters);
  }, []);

  const dateFormate = (row, columnName) => {
    return (
      <>
        {row[columnName]
          ? moment(new Date(row[columnName])).format("MM/DD/YYYY")
          : "-"}
      </>
    );
  };

  const formatter = (row, columnName) => {
    return <>{row[columnName] || "-"}</>;
  };

  const columns = [
    {
      dataField: "patientFirstName",
      text: "Patient First Name",
      sort: true,
      width: 120,
      cellRenderer: (row) => formatter(row, "patientFirstName"),
      inputType: "text",
    },
    {
      dataField: "patientLastName",
      text: "Patient Last Name",
      sort: true,
      width: 120,
      cellRenderer: (row) => formatter(row, "patientLastName"),
      inputType: "text",
    },
    {
      dataField: "patientDOB",
      text: "Patient Date of Birth",
      width: 90,
      cellRenderer: (row) => dateFormate(row, "patientDOB"),
      inputType: "date",
      sort: true,
    },
    {
      dataField: "medicalRecordNumber",
      text: "Medical Record Number",
      headerStyle: { width: "170px" },
      cellRenderer: (row) => formatter(row, "medicalRecordNumber"),
      sort: true,
      inputType: "number",
    },
    {
      dataField: "encounterDate",
      text: "Encounter Date",
      width: 100,
      cellRenderer: (row) => dateFormate(row, "encounterDate"),
      inputType: "date",
      sort: true,
    },
    {
      dataField: "serviceLocation",
      text: "Service Location",
      headerStyle: { width: "200px" },
      cellRenderer: (row) => formatter(row, "serviceLocation"),
      sort: true,
      inputType: "text",
    },
    {
      dataField: "visitEncounterNumber",
      text: "Visit Encounter Number",
      headerStyle: { width: "170px" },
      cellRenderer: (row) => formatter(row, "visitEncounterNumber"),
      sort: true,
      inputType: "number",
    },
    {
      dataField: "providerNPI",
      text: "Rendering Provider NPI",
      headerStyle: { width: "210px" },
      cellRenderer: (row) => formatter(row, "providerNPI"),
      sort: true,
      inputType: "text",
    },
    {
      dataField: "providerFirstName",
      text: "Rendering Provider First Name",
      headerStyle: { width: "210px" },
      cellRenderer: (row) => formatter(row, "providerFirstName"),
      sort: true,
      inputType: "text",
    },
    {
      dataField: "providerLastName",
      text: "Rendering Provider Last Name",
      headerStyle: { width: "220px" },
      cellRenderer: (row) => formatter(row, "providerLastName"),
      sort: true,
      inputType: "text",
    },
  ];

  const handlePageChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      let combine = { ...filter, filters: [...colChangedFilter] };
      fetchEncounters(combine, true);
      setInitFilter(combine);
    } else {
      fetchEncounters(filter);
      setInitFilter(filter);
    }
  };

  const handleSort = (filter) => {
    fetchEncounters(filter);
    setInitFilter(filter);
  };

  const handleSearchColumnFilters = (columnFilters) => {
    if (columnFilters.length) {
      let filter = {
        ...initFilter,
        filters: [...columnFilters],
        currentPage: 1,
      };
      fetchEncounters(filter, true);
      setInitFilter(filter);
    }
  };

  const handleFilterCancel = () => {
    initialFilters.filters = [];
    fetchEncounters(initialFilters);
  };

  const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      let combine = { ...filter, filters: colChangedFilter };
      fetchEncounters(combine, true);
      setInitFilter(combine);
    } else {
      fetchEncounters(filter);
      setInitFilter(filter);
    }
  };

  return (
    <div className="table-card scroll-table position-relative border-0">
      <ReactStrapTable
        id="encountes"
        height={50 * data.length}
        fixedColumn
        columns={columns}
        data={data}
        handleSort={handleSort}
        onSearchColumnFilters={handleSearchColumnFilters}
        onFilterCancel={handleFilterCancel}
        hasPagination
        pageSize={initFilter.pageSize}
        onPageSizeChange={onPageSizeChange}
        currentPage={initFilter.currentPage}
        totalRecords={totalSize}
        onPageChange={handlePageChange}
        filters={initFilter}
      ></ReactStrapTable>
    </div>
  );
};

export default Encounters;
